import { connect } from "react-redux"
import { updateStaticFilter } from "../../store"

import StaticFilterBoxes from "."

const mapDispatchToProps = dispatch => ({
  staticFilterChange: (name, checked) => {
    dispatch(updateStaticFilter(name, checked))

    /* istanbul ignore next */
    if (checked && window.gtag !== undefined) {
      /* istanbul ignore next */
      window.gtag("event", "StaticFilters", {
        category: "StaticFilters",
        action: "selectStaticFilter",
        label: name,
      })
    }
  },
})

const mapStateToProps = ({ staticFilters }) => ({
  onlyRented: staticFilters.onlyRented,
  onlyStationary: staticFilters.onlyStationary,
})

const StaticFilterBoxesWithStore = connect(
  mapStateToProps,
  mapDispatchToProps
)(StaticFilterBoxes)

export default StaticFilterBoxesWithStore
